
export const AUTH_URL = '/oauth/token';

export const USER_URL = '/api/user';
export const USER_LIST_URL = '/api/user/list';
export const CLIENT_URL = '/api/clients';
export const NVI_URL = '/api/nvi';
export const TRANSACTION_URL = 'api/transactions'
export const AUTH_URL_MAGIC_LINK = 'api/user/magic-link-token';
export const ROLE_LIST = '/api/roles/list';
export const DASHBOARD = '/api/dashboard';
